// extracted by mini-css-extract-plugin
export default {"stepContainer":"stepContainer__3kR6i","stepCopy":"stepCopy__1NfxW"};